/* tslint:disable */
/* eslint-disable */
export enum WorkMyTodoGroupEnum {
  Overdue = 'overdue',
  ThisWeek = 'thisWeek',
  Later = 'later',
  NoDue = 'noDue'
}
